import Image from "next/image";
import React from "react";
import CocoCustomerService from "public/assets/coco-customer-service.svg";
import CocoSad from "public/assets/coco-sad.svg";

import {
  CocoWithTyping,
  Panel,
  PanelAvatar,
  PanelBody,
  PanelClose,
  PanelDot,
  PanelHeader,
  PanelTitle,
  RetryButton,
  TypingBubble
} from "./odoo-live-chat-launcher.styles";

interface IOdooLiveChatStatusPanelProps {
  variant: "connecting" | "offline";
  onClose: () => void;
  onRetry: () => void;
}

// Shaped like the chat window: shown while the widget loads ("connecting") and
// when nobody is available or the widget did not come up in time ("offline").
export const OdooLiveChatStatusPanel: React.FC<IOdooLiveChatStatusPanelProps> = ({
  variant,
  onClose,
  onRetry
}) => {
  const isOffline = variant === "offline";

  return (
    <Panel role="dialog" aria-label="Kakak Siaga">
      <PanelHeader>
        <PanelAvatar>
          <Image src={CocoCustomerService} alt="" fill />
          {isOffline && <PanelDot $isOnline={false} />}
        </PanelAvatar>
        <PanelTitle>
          <strong>Kakak Siaga</strong>
          <span>{isOffline ? "Belum tersambung" : "Menghubungkan…"}</span>
        </PanelTitle>
        <PanelClose type="button" aria-label="Tutup" onClick={onClose}>
          ×
        </PanelClose>
      </PanelHeader>
      {isOffline ? (
        <PanelBody role="status">
          <Image src={CocoSad} alt="" width={160} height={160} />
          <h3>Kakak Siaga belum bisa terhubung, nih</h3>
          <p>Tenang, coba sekali lagi, ya</p>
          <RetryButton type="button" onClick={onRetry}>
            Coba lagi
          </RetryButton>
        </PanelBody>
      ) : (
        <PanelBody role="status" aria-busy="true">
          <CocoWithTyping>
            <Image src={CocoCustomerService} alt="" fill />
            <TypingBubble>
              <span />
              <span />
              <span />
            </TypingBubble>
          </CocoWithTyping>
          <h3>Bentar, ya. Kakak Siaga lagi meluncur ke sini…</h3>
        </PanelBody>
      )}
    </Panel>
  );
};
